"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useSyncExternalStore } from "react";
import type { WaveMentionTypeaheadOption } from "./WaveMentionsPlugin";
import WaveMentionsTypeaheadMenuItem from "./WaveMentionsTypeaheadMenuItem";
export default function WaveMentionsTypeaheadMenu(t0) {
  const $ = _c(16);
  const {
    selectedIndex,
    options,
    setHighlightedIndex,
    selectOptionAndCleanUp
  } = t0;
  const menuRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (globalThis.window === undefined) {
        return "bottom";
      }
      const win = globalThis.window;
      const element = menuRef.current;
      if (!element) {
        return "bottom";
      }
      const rect = element.getBoundingClientRect();
      const spaceAbove = rect.top;
      const spaceBelow = win.innerHeight - rect.bottom;
      return spaceBelow >= spaceAbove ? "bottom" : "top";
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getPositionSnapshot = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = onStoreChange => {
      if (globalThis.window === undefined) {
        return _temp;
      }
      const win_0 = globalThis.window;
      const handleChange = () => onStoreChange();
      win_0.addEventListener("resize", handleChange);
      let resizeObserver = null;
      if (typeof ResizeObserver !== "undefined" && menuRef.current) {
        resizeObserver = new ResizeObserver(handleChange);
        resizeObserver.observe(menuRef.current);
      }
      handleChange();
      return () => {
        win_0.removeEventListener("resize", handleChange);
        resizeObserver?.disconnect();
      };
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const subscribeToPosition = t2;
  const position = useSyncExternalStore(subscribeToPosition, getPositionSnapshot, _temp2);
  const t3 = `tailwind-scope tw-absolute tw-z-50 tw-w-[20rem] tw-rounded-lg tw-bg-iron-800 tw-p-2 tw-shadow-xl tw-ring-1 tw-ring-black tw-ring-opacity-5 ${position === "top" ? "tw-bottom-full tw-mb-1" : "tw-top-full tw-mt-1"}`;
  let t4;
  if ($[2] !== options || $[3] !== selectOptionAndCleanUp || $[4] !== selectedIndex || $[5] !== setHighlightedIndex) {
    let t5;
    if ($[7] !== selectOptionAndCleanUp || $[8] !== selectedIndex || $[9] !== setHighlightedIndex) {
      t5 = (option, i) => <WaveMentionsTypeaheadMenuItem key={option.key} index={i} isSelected={selectedIndex === i} onClick={() => {
        setHighlightedIndex(i);
        selectOptionAndCleanUp(option);
      }} onMouseEnter={() => {
        setHighlightedIndex(i);
      }} name={option.name} picture={option.picture} setRefElement={element_0 => option.setRefElement(element_0)} />;
      $[7] = selectOptionAndCleanUp;
      $[8] = selectedIndex;
      $[9] = setHighlightedIndex;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = options.map(t5);
    $[2] = options;
    $[3] = selectOptionAndCleanUp;
    $[4] = selectedIndex;
    $[5] = setHighlightedIndex;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <ul className="tw-mx-0 tw-mb-0 tw-flex tw-list-none tw-flex-col tw-px-2">{t4}</ul>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div ref={menuRef} className={t3}>{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp2() {
  return "bottom";
}
function _temp() {}